import CloseIcon from '@mui/icons-material/Close';
import { Box, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";

interface PopupMessageProps {
  title?: string,
  onClose: () => void;
  children: ReactNode
}

export const PopupMessage: React.FC<PopupMessageProps> = ({ onClose, title = 'Disclaimer', children }) => (
  <Typography component="div" variant="popup-message">
    <Paper data-automation="page-help-header" elevation={4} square>{title} <CloseIcon onClick={onClose} /></Paper>
    <Box>
      {children}
    </Box>
  </Typography >
)
